import {Card,CardActions,CardContent,CardMedia,Typography,Button,ButtonBase } from '@mui/material'
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon  from '@mui/icons-material/MoreHoriz';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deletePost ,likePost } from '../../../actions/posts';
import moment from 'moment' ;           //package to show the time since posting a post



const Post = ({post,setCurrentId}) => {
  
  const dispatch = useDispatch();       //getting the dispatch function
  const navigate = useNavigate();       //getting the router-dom navigate function = useHistory upgrade
  const user = JSON.parse(localStorage.getItem('profile'));    //get the logged user from the localstorage
  
  const [likes, setLikes] = useState(post?.likes) ;            //store the likes value
  const userId = user?.result.googleId || user?.result?._id;    //check & get id type (custom or google)
  const handleLike = async () => {                              //function for onClick of like button
    dispatch(likePost(post._id));
    if (post?.likes?.find((like) => like === userId)) {
      setLikes(post.likes.filter((id) => id !== userId));
    } else {
      setLikes([...post.likes, userId]);
    }
  };

  //sub-component : contains the logic of the like buttton (like/unlike icons)
  const Likes = () => {
    if (likes.length > 0) {
      return likes.find((like) => like === userId)  ? (
          <><ThumbUpAltIcon fontSize="small" />&nbsp;{likes.length > 2 ? `You and ${likes.length - 1} others` : `${likes.length} like${likes.length > 1 ? 's' : ''}` }</>
        ) : (
          <><ThumbUpAltOutlinedIcon fontSize="small" />&nbsp;{likes.length} {likes.length === 1 ? 'Like' : 'Likes'}</>
        );
    }
    return <><ThumbUpAltOutlinedIcon fontSize="small" />&nbsp;Like</>;
  };
  
  //recieving the data of the props & passing it to our single post component created using material ui
  return (
    <Card sx={{display: 'flex',flexDirection: 'column',justifyContent: 'space-between',borderRadius: '15px',height: '100%',position: 'relative'}} raised elevation={6}>
        <ButtonBase component="span" name="test" sx={{display: 'block',textAlign: 'initial'}} onClick={()=>navigate(`/posts/${post._id}`)}>
        <CardMedia image={post.selectedFile} title={post.title} sx={{height: 0,paddingTop: '56.25%',backgroundColor: 'rgba(0, 0, 0, 0.5)',backgroundBlendMode: 'darken'}} />
        
        <div style={{position: 'absolute',top: '20px',left: '20px',color: 'white' }}>
        <Typography variant='h6'>{post.name}</Typography>
        <Typography variant='body2'>{moment(post.createdAt).fromNow()}</Typography>
        </div>
       
        {/* check if the logged (google or custom) user is the creator of the post 
           , so we can only show edit icon to the post creator so user can only edit his own post */}
        {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
        <div style={{position: 'absolute',top: '20px',right: '20px',color: 'white'}}>
          <Button style={{color:'white'}} size='small' onClick={(e)=>{ e.stopPropagation(); setCurrentId(post._id)}}>
              <MoreHorizIcon fontSize='default'/>
          </Button>
        </div> )}

        <div style={{display: 'flex',justifyContent: 'space-between',margin: '20px',flexDirection:'column' }}>
         <Typography variant='body2' color='textSecondary'>{post.tags.map((tag)=>`#${tag} `)}</Typography>
         </div>
         <Typography sx={{padding: '0 16px'}} variant='h5' >{post.title}</Typography>
         <CardContent><Typography  variant='body2' color='textSecondary' gutterBottom>{post.message}</Typography></CardContent>
         </ButtonBase>

          <CardActions sx={{padding: '0 16px 8px 16px',display: 'flex',justifyContent: 'space-between'}}>
           
           <Button color='primary' size='small' disabled={!user?.result} onClick={handleLike}>
             <Likes />
           </Button>

           {/* check if the logged (google or custom) user is the creator of the post 
           , so we can only show delete button to the post creator so user can only delete his own post */}
           {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
           <Button color='primary' size='small' onClick={()=>{dispatch(deletePost(post._id)); navigate('/')}} >
              <DeleteIcon fontSize='small' sx={{marginRight:'7px'}}/>
              Delete
           </Button> )}
           
          </CardActions>         

    </Card>
  )
}

export default Post